import { useEffect, useState } from "react";

interface CountdownProps {
  expiryDate: string;
  locale?: string;
  variant?: "default" | "compact";
  expiredLabel?: string;
}

export const ProposalCountdown = ({ expiryDate, locale = "en-US", variant = "default", expiredLabel }: CountdownProps) => {
  const [timeLeft, setTimeLeft] = useState<string>("");
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const expiry = new Date(expiryDate).getTime();
      const difference = expiry - now;

      if (difference <= 0) {
        setIsExpired(true);
        setTimeLeft(expiredLabel || "expired");
        return;
      }

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));

      if (variant === "compact") {
        if (days > 0) {
          setTimeLeft(`${days}d ${hours}h`);
        } else if (hours > 0) {
          setTimeLeft(`${hours}h ${minutes}m`);
        } else {
          setTimeLeft(`${minutes}m`);
        }
      } else {
        if (days > 0) {
          setTimeLeft(`in ${days}d ${hours}h`);
        } else if (hours > 0) {
          setTimeLeft(`in ${hours}h ${minutes}m`);
        } else {
          setTimeLeft(`in ${minutes} minutes`);
        }
      }
    };

    calculateTimeLeft();
    const interval = setInterval(calculateTimeLeft, 60000); // Update every minute

    return () => clearInterval(interval);
  }, [expiryDate]);

  if (isExpired) {
    return (
      <span className="text-xs text-destructive font-medium">
        {timeLeft}
      </span>
    );
  }

  return (
    <span className="text-xs text-destructive font-medium">
      {variant === "default" ? `• ${timeLeft}` : timeLeft}
    </span>
  );
};
